define(['underscore'], function (_) {
    'use strict';

    return {
        name: 'advertisingCtrl',
        arguments: [
            '$interval',
            '$scope',
            '$timeout',
            'ErrorHandler',
            'Facebook',
            'FacebookAds',
            'Profile',
            'Site',
            function (
                $interval,
                $scope,
                $timeout,
                ErrorHandler,
                Facebook,
                FacebookAds,
                Profile,
                Site
            ) {
                $scope.ads = FacebookAds.getAll();
                $interval(function () {
                    // Reload ads every 5 minutes so status is current
                    FacebookAds.getAll().$promise.then(function (newAds) {
                        $scope.ads = newAds;
                    });
                }, 300000);
                $scope.site = Site.getSite();

                var targetUrls = [];
                var urlCities = {};
                $scope.site.$promise.then(function (site) {
                    $scope.newAd = {
                        cityOrZip: 'city',
                    };

                    Profile.getProfile(false, function (profile) {
                        $scope.newAd.state = profile.profile.state;
                        urlCities[site.domain] = profile.profile.city;
                    });

                    targetUrls.push(site.domain);

                    if (
                        site &&
                        site.hasOwnProperty('settings') &&
                        site.settings
                    ) {
                        if (
                            site.settings.hasOwnProperty('options') &&
                            site.settings.options.hasOwnProperty(
                                'dynamicCityDefault'
                            ) &&
                            site.settings.options.dynamicCityDefault
                        ) {
                            targetUrls.push(
                                site.domain +
                                    '/' +
                                    site.settings.options.dynamicCityDefault
                                        .replace(/[^0-9a-zA-Z]/g, '-')
                                        .toLowerCase()
                            );
                            urlCities[targetUrls[targetUrls.length - 1]] =
                                site.settings.options.dynamicCityDefault;
                        }

                        if (
                            site.settings.hasOwnProperty('dynamicCities') &&
                            site.settings.dynamicCities.length > 0
                        ) {
                            angular.forEach(
                                site.settings.dynamicCities,
                                function (city) {
                                    targetUrls.push(
                                        site.domain + '/' + city.nameSlug
                                    );
                                    urlCities[
                                        targetUrls[targetUrls.length - 1]
                                    ] = city.name;
                                }
                            );
                        }
                    }
                    $scope.targetUrls = _.uniq(targetUrls);

                    if ($scope.targetUrls.length == 1) {
                        $scope.newAd.url = site.domain;
                    }

                    $scope.domainResults = Profile.checkDomain(site.domain);
                });

                $scope.creatingAd = false;
                $scope.createAd = function (newAd, form) {
                    if (form) {
                        form.submitted = true;
                    }
                    if (!$scope.creatingAd && (!form || form.$valid)) {
                        $scope.adError = null;
                        $scope.creatingAd = true;
                        FacebookAds.create(newAd).$promise.then(
                            function () {
                                $scope.newAd = {
                                    cityOrZip: 'city',
                                };

                                if ($scope.targetUrls.length == 1) {
                                    $scope.newAd.url = $scope.site.domain;
                                }

                                Profile.getProfile(false, function (profile) {
                                    $scope.newAd.state = profile.profile.state;
                                });

                                FacebookAds.getAll().$promise.then(function (
                                    newAds
                                ) {
                                    $scope.ads = newAds;
                                });

                                $('#add-ad-modal').foundation(
                                    'reveal',
                                    'close'
                                );

                                $scope.creatingAd = false;
                                if (form) {
                                    form.submitted = false;
                                }
                            },
                            function (result) {
                                // Error
                                $scope.adError = ErrorHandler.getMessage(
                                    result,
                                    'Error creating ad.  Please try again'
                                );

                                $scope.creatingAd = false;
                                if (form) {
                                    form.submitted = false;
                                }
                            }
                        );
                    }
                };

                function setFacebookToken(newFacebookToken) {
                    if (newFacebookToken) {
                        $scope.ads.$promise.then(function () {
                            FacebookAds.updateLoginStatus().then(function (
                                savedLoginToken
                            ) {
                                if (!savedLoginToken || $scope.ads.length < 1) {
                                    FacebookAds.setToken(newFacebookToken).then(
                                        function () {
                                            $scope.facebookLoggedIn = newFacebookToken;
                                        }
                                    );
                                } else {
                                    Facebook.api(
                                        '/me',
                                        { access_token: savedLoginToken },
                                        function (savedData) {
                                            Facebook.api(
                                                '/me',
                                                {
                                                    access_token: newFacebookToken,
                                                },
                                                function (newData) {
                                                    if (
                                                        savedData.id ==
                                                        newData.id
                                                    ) {
                                                        FacebookAds.setToken(
                                                            newFacebookToken
                                                        ).then(function () {
                                                            $scope.facebookLoggedIn = newFacebookToken;
                                                        });
                                                    } else {
                                                        $scope.savedFacebookToken = savedLoginToken;
                                                        $scope.savedFacebookTokenName =
                                                            savedData.name;
                                                    }
                                                }
                                            );
                                        }
                                    );
                                }
                            });
                        });
                    }
                }

                Facebook.getLoginStatus(function (response) {
                    if (response.status === 'connected') {
                        setFacebookToken(response.authResponse.accessToken);
                    }
                });

                $scope.facebookLogin = function () {
                    Facebook.login(
                        function (response) {
                            if (response.authResponse.accessToken) {
                                FacebookAds.setToken(
                                    response.authResponse.accessToken
                                ).then(function () {
                                    $scope.facebookLoggedIn =
                                        response.authResponse.accessToken;
                                    FacebookAds.updateLoginStatus().then(
                                        function (isLoggedIn) {
                                            $scope.savedFacebookToken = isLoggedIn;
                                        }
                                    );
                                });
                            }
                        },
                        { scope: FacebookAds.permissions.join(',') }
                    );
                };

                $scope.saveAdStatus = function (ad) {
                    switch (ad.status) {
                        case 'active':
                            ad.$activate().catch(function () {
                                alert(
                                    'There was a problem communicating with Facebook.  Please wait a few minutes and try again.'
                                );
                                ad.status = 'paused';
                            });
                            break;
                        case 'paused':
                            ad.$pause().catch(function () {
                                alert(
                                    'There was a problem communicating with Facebook.  Please wait a few minutes and try again.'
                                );
                                ad.status = 'active';
                            });
                            break;
                    }
                };

                $scope.setPage = function (newPageId) {
                    FacebookAds.setPage(newPageId);
                };

                $scope.setAdAccount = function (newAdAccountId) {
                    FacebookAds.setAdAccount(newAdAccountId);
                };

                $scope.$watch('facebookLoggedIn', function (newValue) {
                    if (newValue) {
                        Facebook.api(
                            '/me/accounts',
                            { access_token: FacebookAds.token },
                            function (response) {
                                $scope.facebookPages = response.data;

                                if (
                                    $scope.facebookPages.length == 1 &&
                                    !$scope.site.advertisingSettings
                                        .facebookPageId
                                ) {
                                    $scope.setPage($scope.facebookPages[0].id);
                                }
                            }
                        );

                        Facebook.api(
                            '/me/adaccounts?fields=name,account_id,account_status,funding_source',
                            { access_token: FacebookAds.token },
                            function (response) {
                                $scope.facebookAdAccounts = response.data;

                                $scope.facebookAdAccounts = [];

                                // Check for valid/active ad accounts
                                angular.forEach(response.data, function (
                                    accountInfo
                                ) {
                                    if (
                                        accountInfo.account_id &&
                                        (accountInfo.account_status == 1 || // ACTIVE
                                            accountInfo.account_status == 3 || // UNSETTLED
                                            accountInfo.account_status == 7 || // PENDING_RISK_REVIEW
                                            accountInfo.account_status == 8 || // PENDING_SETTLEMENT
                                            accountInfo.account_status == 9 || // IN_GRACE_PERIOD
                                            accountInfo.account_status ==
                                                201) && // ANY_ACTIVE
                                        accountInfo.funding_source
                                    ) {
                                        $scope.facebookAdAccounts.push(
                                            accountInfo
                                        );
                                    }
                                });

                                if (
                                    $scope.facebookAdAccounts.length == 0 &&
                                    response.data.length > 0
                                ) {
                                    // All the ad accounts are being considered invalid, which is happening incorrectly sometimes
                                    if (typeof Raven != 'undefined' && Raven) {
                                        Raven.captureMessage(
                                            'No valid ad account',
                                            {
                                                level: 'warning',
                                                extra: {
                                                    facebookResponse:
                                                        response.data,
                                                },
                                            }
                                        );
                                    }
                                }

                                if (
                                    $scope.facebookAdAccounts.length == 1 &&
                                    !$scope.site.advertisingSettings
                                        .facebookAdId
                                ) {
                                    $scope.setAdAccount(
                                        $scope.facebookAdAccounts[0].account_id
                                    );
                                }
                            }
                        );
                    }
                });

                $scope.$watch('newAd.url', function (newValue) {
                    if (urlCities.hasOwnProperty(newValue)) {
                        $scope.newAd.city = urlCities[newValue];
                    }
                });

                FacebookAds.getDailyBudget().then(function (response) {
                    $scope.dailyBudget = response.data;
                });

                var updateTimeout = false;
                $scope.updateDailyBudget = function () {
                    if (updateTimeout) {
                        $timeout.cancel(updateTimeout);
                    }
                    updateTimeout = $timeout(function () {
                        FacebookAds.setDailyBudget($scope.dailyBudget);
                        updateTimeout = false;
                    }, 500);
                };
            },
        ],
    };
});
